import AutoCompleteDebounce from "Components/AutoCompleteDebounce";
import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  Select,
  Space,
  Typography,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { useEffect } from "react";
const { Text } = Typography;
const { Option } = Select;
const VenderForm = ({
  form,
  fieldOptions,
  selectedPatientData,
  handleAutocompleteChange,
  handleAutocompleteSelect,
  editData,
  showReferenceIdModal,
}) => {
  useEffect(() => {
    if (selectedPatientData) {
      form.setFieldsValue({
        name: selectedPatientData.name || "",
        contact_number: selectedPatientData.contact_number || "",
        vendor_id: selectedPatientData.vendor_id || "",
        GSTIN_number: selectedPatientData.GSTIN_number || "",
      });
    } else {
      form.setFieldsValue({
        name: "",
        contact_number: "",
        vendor_id: "",
        GSTIN_number: "",
      });
    }
  }, [selectedPatientData]);
  return (
    <>
      <Form.Item name="billing_date" label="Bill Date" initialValue={dayjs()}>
        <DatePicker
          style={{ width: "100%" }}
          format="DD-MM-YYYY"
          disabledDate={(current) =>
            current && current < dayjs().startOf("day")
          }
        />
      </Form.Item>
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Vendor name is required" }]}
      >
        <AutoCompleteDebounce
          options={fieldOptions.name.options}
          onSelect={(value, option) =>
            handleAutocompleteSelect("name", value, option)
          }
          onSearch={(value) => handleAutocompleteChange("name", value)}
          placeholder="Select or type to search"
          loading={fieldOptions.name.loading}
        />
      </Form.Item>
      <Form.Item
        name="contact_number"
        label="Contact No"
        rules={[{ required: true, message: "Contact no is required" }]}
      >
        <AutoCompleteDebounce
          options={fieldOptions.contact_number.options}
          onSelect={(value, option) =>
            handleAutocompleteSelect("contact_number", value, option)
          }
          onSearch={(value) =>
            handleAutocompleteChange("contact_number", value)
          }
          placeholder="Select or type to search"
          loading={fieldOptions.contact_number.loading}
        />
      </Form.Item>
      <Form.Item
        name="vendor_id"
        label="Vendor ID"
        rules={[{ required: true, message: "Vendor id is required" }]}
      >
        <AutoCompleteDebounce
          options={fieldOptions.vendor_id.options}
          onSelect={(value, option) =>
            handleAutocompleteSelect("vendor_id", value, option)
          }
          onSearch={(value) => handleAutocompleteChange("vendor_id", value)}
          placeholder="Select or type to search"
          loading={fieldOptions.vendor_id.loading}
        />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <Form.Item
            name="payment_mode"
            label="Payment Mode"
            rules={[
              {
                required: getFieldValue("payment_status") === "Paid",
                message: "Payment mode is required",
              },
            ]}
          >
            <Select disabled={false}>
              <Option value="CASH">Cash</Option>
              <Option value="CARD">Card</Option>
              <Option value="UPI">UPI</Option>
              <Option value="CHEQUE">Cheque</Option>
              <Option value="Net Banking">Net Banking</Option>
            </Select>
          </Form.Item>
        )}
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <Form.Item
            name="reference_id"
            // label="Reference ID"
            label={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Space>
                  <span>Reference ID</span>
                  {(editData?.is_generated &&
                    editData?.payment_status === "Partially paid" && editData?.payment_details?.[0]?.paid_date) && (
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={showReferenceIdModal}
                      >
                        Click
                      </span>
                    )}
                </Space>
              </div>
            }
            rules={[
              {
                required:
                  getFieldValue("payment_mode") &&
                  getFieldValue("payment_mode") !== "CASH" &&
                  (getFieldValue("payment_status") == "Paid" ||
                    getFieldValue("payment_status") === "Partially paid"),
                message: "Reference ID is required",
              },
            ]}
          >
            <Input disabled={getFieldValue("payment_mode") == "CASH"} />
          </Form.Item>
        )}
      </Form.Item>

      <Form.Item
        name="payment_status"
        label="Payment Status"
        initialValue={"Draft"}
        rules={[{ required: true }]}
      >
        <Select disabled={false}>
          {!editData?.is_generated && <Option value="Draft">Draft</Option>}
          {editData?.payment_status !== "Partially paid" && (
            <Option value="Pending">Pending</Option>
          )}
          <Option value="Paid">Paid</Option>
          <Option value="Partially paid">Partially paid</Option>
          {editData?.payment_status &&
            editData?.payment_status !== "Draft" &&
            editData?.payment_status !== "Partially paid" && (
              <Option value="Cancelled">Cancelled</Option>
            )}
        </Select>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) =>
          getFieldValue("payment_status") === "Cancelled" && (
            <Form.Item
              name="reason_for_cancel"
              label="Reason for Cancel"
              rules={[
                {
                  required: getFieldValue("payment_status") == "Cancelled",
                  message: "This field cannot be empty",
                },
              ]}
            >
              <TextArea disabled={false} />
            </Form.Item>
          )
        }
      </Form.Item>
      <Form.Item name="GSTIN_number" label="GST IN">
        <Input disabled={true} />
      </Form.Item>
      <Form.Item
        name="vendor_order_id"
        label="Invoice Id"
        rules={[
          {
            required: true,
            message: "Vender Order Id is required",
          },
        ]}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default VenderForm;
